import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import { getDate, getTodayDate } from "../../util";
import NumberInputField from "../../components/form/NumberInputField";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";

const BankReconciliation = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };
  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Bank Reconciliation</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col sm:px-10 "
      >
        <div>
          <InputField
            register={register}
            name="bank_name"
            label="Bank Name"
            errors={errors.bank_name}
            type="text"
          />
        </div>
        <div>
          <InputField
            register={register}
            name="account_number"
            label="Account Number"
            errors={errors.account_number}
            type="text"
          />
        </div>
        <div>
          <InputField
            register={register}
            name="account_number"
            label="Account Number"
            errors={errors.account_number}
            type="text"
          />
        </div>
        <div className="sm:flex justify-between items-baseline gap-2 sm:gap-4 md:gap-20">
          <p className="whitespace-nowrap">Statement Period</p>
          <InputField
            register={register}
            name="start_date"
            errors={errors.start_date}
            type="date"
            defaultValue={getTodayDate()}
          />
          <InputField
            register={register}
            name="end_date"
            errors={errors.end_date}
            type="date"
            defaultValue={getDate(90)}
          />
        </div>
        <div className="sm:flex justify-between items-baseline gap-2 sm:gap-4 md:gap-20">
          <InputField
            register={register}
            name="bank_opening_balance"
            label="Opening Balance as per Bank Statement"
            type="number"
            errors={errors.bank_opening_balance}
          />
          <div className="flex-1"></div>
        </div>
        <div className="sm:flex justify-between items-baseline gap-2 sm:gap-4 md:gap-20">
          <InputField
            register={register}
            name="bank_closing_balance"
            label="Closing Balance as per Bank Statement"
            type="number"
            errors={errors.bank_closing_balance}
          />
          <div className="flex-1"></div>
        </div>
        <div className="sm:flex justify-between items-baseline gap-2 sm:gap-4 md:gap-20">
          <InputField
            register={register}
            name="book_opening_balance"
            label="Opening Balance as per Book"
            type="number"
            errors={errors.book_opening_balance}
          />
          <div className="flex-1"></div>
        </div>
        <h5 className="p-5 flex items-center justify-center">Adjustmemts</h5>
        <div className="mb-4 border border-bkg2 flex flex-col gap-y-3 ">
          <div className="border-b border-bkg2 flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Description
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5">
              <p>Amount (Credit)</p>
              <p>Amount (Debit)</p>
            </div>
          </div>
          <div className="flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Outstanding Cheques
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5 pr-3">
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Deposit in Transit
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5 pr-3">
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Bank Fees
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5 pr-3">
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Error in Books
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5 pr-3">
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
            </div>
          </div>
          <div className="border-t border-bkg2 flex items-center justify-between gap-5 py-3">
            <p className="pl-3 text-sm sm:text-base min-w-36 sm:min-w-52">
              Total Adjustmentts
            </p>
            <div className=" flex-1 flex items-center justify-evenly gap-5 pr-3">
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
              <div>
                <NumberInputField
                  register={register}
                  name="outstanding_cheque_debit"
                  type="number"
                  errors={errors.outstanding_cheque_debit}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Adjustment End */}
        <InputField
          register={register}
          label="Final Reconciliation Balance"
          name="final_recon_balance"
          type="number"
        />
        <TextAreaField register={register} name="comments" label="Comments" />

        <ResourseButtons link to="/accounts/maintenance" />
      </form>
    </MainContainer>
  );
};

export default BankReconciliation;
